import { useHandler } from "@redotech/react-util/hook";
import {
  OmsAvailableInventoryConditionStep,
  OmsCustomAttributeNumber1ConditionStep,
  OmsCustomAttributeNumber2ConditionStep,
  OmsCustomAttributeNumber3ConditionStep,
  OmsCustomerOrderCountConditionStep,
  OmsCustomNumber1ConditionStep,
  OmsCustomNumber2ConditionStep,
  OmsCustomNumber3ConditionStep,
  OmsDestinationForecastTemperatureConditionStep,
  OmsItemAmountConditionStep,
  OmsItemQuantityConditionStep,
  OmsPackageWeightOzConditionStep,
  OmsProductCustomNumber1ConditionStep,
  OmsProductCustomNumber2ConditionStep,
  OmsProductCustomNumber3ConditionStep,
  OmsTaxesPaidConditionStep,
  OmsTotalValueConditionStep,
} from "@redotech/redo-flows-common/oms/conditions";
import { OmsConditionStep } from "@redotech/redo-flows-common/steps";
import { memo } from "react";
import { DeepPartial } from "..";
import { SingleNumberStepInput } from "../common/single-number-step-input";

export const OmsSingleNumberStepInput = memo(function IntegerStepInput({
  step,
  setStep,
  money,
  integer,
}: {
  step:
    | DeepPartial<OmsTotalValueConditionStep>
    | DeepPartial<OmsTaxesPaidConditionStep>
    | DeepPartial<OmsPackageWeightOzConditionStep>
    | DeepPartial<OmsItemQuantityConditionStep>
    | DeepPartial<OmsItemAmountConditionStep>
    | DeepPartial<OmsAvailableInventoryConditionStep>
    | DeepPartial<OmsCustomNumber1ConditionStep>
    | DeepPartial<OmsCustomNumber2ConditionStep>
    | DeepPartial<OmsCustomNumber3ConditionStep>
    | DeepPartial<OmsCustomAttributeNumber1ConditionStep>
    | DeepPartial<OmsCustomAttributeNumber2ConditionStep>
    | DeepPartial<OmsCustomAttributeNumber3ConditionStep>
    | DeepPartial<OmsCustomerOrderCountConditionStep>
    | DeepPartial<OmsProductCustomNumber1ConditionStep>
    | DeepPartial<OmsProductCustomNumber2ConditionStep>
    | DeepPartial<OmsProductCustomNumber3ConditionStep>
    | DeepPartial<OmsDestinationForecastTemperatureConditionStep>;
  setStep: (step: DeepPartial<OmsConditionStep>) => void;
  money: boolean;
  integer: boolean;
}) {
  const setMatchValue = useHandler((matchValue: number) => {
    setStep({ ...step, matchValue });
  });

  return (
    <SingleNumberStepInput
      money={money}
      setValue={setMatchValue}
      stepInteger={integer}
      value={step.matchValue}
    />
  );
});
